import React from 'react'
import { api } from '../lib/api.js'

export default function Footer() {
  const year = new Date().getFullYear()
  const [site, setSite] = React.useState(null)

  React.useEffect(() => {
    let live = true
    ;(async () => {
      try {
        const d = await api('/api/site')
        if (live) setSite(d.site || null)
      } catch {
        // ignore
      }
    })()
    return () => { live = false }
  }, [])

  const legalLinks = Array.isArray(site?.footer?.legalLinks) ? site.footer.legalLinks : [
    { label: 'Terms', href: '/terms' },
    { label: 'Privacy', href: '/privacy' }
  ]
  const supportEmail = site?.links?.supportEmail || ''
  const discord = site?.links?.discord || ''
  return (
    <footer className="border-t border-white/10 mt-16">
      <div className="mx-auto max-w-6xl px-4 py-10 text-sm text-white/50 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <div className="text-white/70 font-semibold">{site?.brand?.name || 'DeltaReloaded'}</div>
          <div className="text-xs">{site?.footer?.copyright || `© ${year} DeltaReloaded. All rights reserved.`}</div>
        </div>
        <div className="flex flex-wrap gap-4 text-xs">
          <a className="hover:text-white" href="/media">Media</a>
          <a className="hover:text-white" href="/roadmap">Roadmap</a>
          <a className="hover:text-white" href="/api/presskit/download">Press Kit</a>
          {legalLinks.map((l) => (
            <a key={l.label} className="hover:text-white" href={l.href}>{l.label}</a>
          ))}
          {discord ? <a className="hover:text-white" href={discord} target="_blank" rel="noreferrer">Discord</a> : null}
          {supportEmail ? <a className="hover:text-white" href={`mailto:${supportEmail}`}>Support</a> : null}
        </div>
      </div>
    </footer>
  )
}
